export default __webpack_public_path__ + "043c9c99faa981e22849cb84c089d625.png";